// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_CreateOrigemInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/origens/createOrigem
 *
 * Creates a new origin (origem de orcamento).
 */
import { registerContract } from './validate'

export interface Origens_CreateOrigemInput {
origem_nome: string
origem_franquia_id: number
}

registerContract('Origens_CreateOrigemInput', {
  origem_nome:        { type: 'string',  required: true },
  origem_franquia_id: { type: 'number',  required: true },
})
